import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-146">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-147">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl" data-id="element-148"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-teal-600/5 rounded-full blur-3xl" data-id="element-149"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-teal-500/5 rounded-full" data-id="element-150"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] border border-teal-500/5 rounded-full" data-id="element-151"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32" data-id="element-152">
        <div className="text-center" data-id="element-153">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-154">
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-display font-bold text-white mb-6 leading-tight" data-id="element-155">
              Tu identidad digital.
              <br data-id="element-156" />
              <span className="text-teal-500" data-id="element-157">Segura. Privada. Tuya.</span>
            </h1>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg sm:text-xl text-gray-400 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-158">
            Verifica tu identidad una vez. Úsala en todas partes. TruID te
            permite controlar tus datos personales mientras accedes de forma
            segura a servicios financieros, salud, gobierno y más.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-159">
            <button className="group bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold transition-all flex items-center space-x-2 shadow-lg shadow-teal-500/20 hover:shadow-teal-500/30" data-id="element-160">
              <span data-id="element-161">Descubre cómo funciona</span>
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-162" />
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}